<template>
  <article class="marketplace">
    <v-icon x-large color="primary" class="mr-3">
      mdi-shopping-outline
    </v-icon>
    <div>
      <div class="d-inline-flex">
        <div class="marketplace__title">
          МАРКЕТПЛЕЙС
        </div>
        <div class="marketplace__soon">
          скоро
        </div>
      </div>
      <div class="marketplace__subtitle">
        Магазин решений
      </div>
    </div>
  </article>
</template>

<script>
  export default {
    name: 'MarketplaceCard',
  }
</script>

<style scoped lang="less">
.marketplace {
  display: flex;
  align-items: center;
  cursor: pointer;

  &__title {
    margin-right: 5px;
  }

  &__soon {
    font-size: 10px;
    color: #EA306B;
    margin-top: -2px;
  }

  &__subtitle {
    font-size: 13px;
    color: #BCC1C9;
  }
}
</style>
